module.exports = __webpack_public_path__ + "assets/img/10e2d6691982aab826c7789d1775033d.png";